export const contentOptimizerKeywordSource = {
    custom: 'custom',
    main: 'main',
};

export const queryKeywordText = 'Exact match keyword';
